import { useMutation } from "@tanstack/react-query";
import axios from "../axios";

const useCreateNewPassword = ({ onSuccess, onError }) => {
  const mutation = useMutation({
    mutationFn: async (params) => {
      const response = await axios.put("/api/auth/create-new-password", {
        token: params.token,
        password: params.password,
      });
      return response;
    },
    onSuccess,
    onError,
  });

  return mutation;
};

export default useCreateNewPassword;
